
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardFooter } from '@/components/ui/card';
import { SuccessHeader } from '@/components/application/submission/SuccessHeader';
import { ExpectationsSection } from '@/components/application/submission/ExpectationsSection';
import { PremiumFeatures } from '@/components/application/submission/PremiumFeatures';
import { ErrorBoundary } from '@/components/application/ErrorBoundary';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const SuccessContent = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Debug logging for success page load
    console.log('Success page loaded:', {
      submittedApplicationId: sessionStorage.getItem('submittedApplicationId'),
      applicationSubmitted: sessionStorage.getItem('applicationSubmitted'),
      currentURL: window.location.href,
      pathname: window.location.pathname
    });
  }, []);

  const handleReturnToDashboard = () => {
    console.log('Returning to dashboard, clearing session storage');
    
    // Clear any session storage that might exist
    sessionStorage.removeItem('submittedApplicationId');
    sessionStorage.removeItem('applicationSubmitted');
    
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50 flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-3xl space-y-8">
        {/* Success Message */}
        <SuccessHeader />

        {/* Main Content Card */}
        <Card className="shadow-lg border-0">
          <CardContent className="space-y-8 pt-6">
            <ExpectationsSection />

            {/* Premium Features Upsell */}
            <PremiumFeatures />
          </CardContent>
          <CardFooter className="flex justify-between items-center">
            <Button 
              variant="outline" 
              className="border-gray-200 hover:bg-gray-50"
              onClick={handleReturnToDashboard}
            >
              Return to Dashboard
            </Button>
            <Button
              variant="outline"
              className="border-gray-200 hover:bg-gray-50"
              onClick={() => window.location.href = 'mailto:support@thepeoapp.com'}
            >
              Contact Support
            </Button>
          </CardFooter>
        </Card>
      </div>
    </div>
  );
};

const Success = () => {
  return (
    <ErrorBoundary>
      <SuccessContent />
    </ErrorBoundary>
  );
};

export default Success;
